export const common: Record<string, string> = {
  // Common
  'common.loading': 'Đang tải…',
  'common.save': 'Lưu',
  'common.cancel': 'Hủy',
  'common.reset': 'Đặt lại',
  'common.back': 'Quay lại',
  'common.add': 'Thêm',
  'common.edit': 'Sửa',
  'common.details': 'Chi tiết',
  'common.delete': 'Xóa',
  'common.signOut': 'Đăng xuất',
  'common.search': 'Tìm kiếm',
  'common.filter': 'Lọc',
  'common.empty': 'Không có dữ liệu',
  'common.close': 'Đóng',
  'common.collapse': 'Thu gọn',
  'common.expand': 'Mở rộng',
  'common.error': 'Lỗi',
  'common.success': 'Thành công',
  'common.ok': 'OK',
  'common.confirm': 'Xác nhận',
  'common.clickToCopy': 'Bấm để sao chép',
  'common.copied': 'Đã sao chép',
  'common.showValue': 'Hiện giá trị',
  'common.hideValue': 'Ẩn giá trị',
  // Web push notifications (Profile card)
  'push.title': 'Thông báo đẩy',
  'push.hint': 'Nhận thông báo lịch trực nhật, đăng ký ca làm việc và sự kiện trên thiết bị này. iPhone/iPad: cần thêm trang vào Màn hình chính (Add to Home Screen) rồi mở từ icon.',
  'push.enable': 'Bật thông báo',
  'push.disable': 'Tắt thông báo',
  'push.test': 'Gửi thử',
  'push.testSent': 'Đã gửi tới {n} thiết bị',
  'push.enabledOk': 'Đã bật thông báo cho thiết bị này',
  'push.denied': 'Trình duyệt đã chặn quyền thông báo — bật lại trong cài đặt trang',
  'push.serverOff': 'Máy chủ chưa cấu hình push',
  'push.unsupported': 'Trình duyệt/chế độ này không hỗ trợ thông báo đẩy (iPhone: thêm vào Màn hình chính trước)',
  'push.promptTitle': 'Bật thông báo?',
  'push.promptBody': 'Nhận thông báo lịch trực, ca làm việc và sự kiện ngay trên thiết bị này.',
  'push.later': 'Để sau',
  'common.required': 'Bắt buộc',
  'common.saving': 'Đang lưu…',
  'common.selected': 'đã chọn',
  'common.selectPlaceholder': '— chọn —',
  'common.noDataYet': 'Chưa có dữ liệu',
  'common.chartPlaceholder': 'Biểu đồ (chờ dữ liệu)',
  'common.toolPanelPending': 'Giao diện công cụ đang chờ',
  // Tracker tab panels
  'panel.search': 'Tìm kiếm…',
  'panel.publisher': 'Nhà phát hành',
  'panel.category': 'Danh mục',
  'panel.downloads': 'Lượt tải',
  'panel.key': 'Khóa',
  'panel.en': 'EN',
  'panel.vi': 'VI',
  'panel.adUnit': 'Ad unit',
  'panel.network': 'Network',
  'panel.ecpm': 'eCPM',
  'panel.assignee': 'Người phụ trách',
  'panel.value': 'Giá trị',
  'panel.condition': 'Điều kiện',
  'panel.pattern': 'Mẫu',
  'panel.input': 'Đầu vào',
  'panel.output': 'Đầu ra',
  'panel.run': 'Chạy',
  'panel.role': 'Vai trò',
  'panel.scope': 'Phạm vi',
  // Tracker — tab labels
  'trk.report': 'Báo cáo',
  'trk.app': 'App',
  'trk.appSpy': 'App Spy',
  'trk.summary': 'Tổng hợp',
  'trk.naming': 'Naming',
  'trk.profit': 'Lợi nhuận',
  'trk.revcost': 'Doanh thu / Chi phí',
  'trk.arpu': 'ARPU',
  'trk.monetAssign': 'Monet Assign',
  'trk.firebaseRc': 'Firebase RC',
  'trk.product': 'Sản phẩm',
  'trk.permissions': 'Phân quyền',
  'trk.col.app': 'App',
  'trk.col.name': 'Tên',
  'trk.col.type': 'Loại',
  'trk.col.status': 'Trạng thái',
  // KPI labels
  'kpi.revenue': 'Doanh thu',
  'kpi.cost': 'Chi phí',
  'kpi.profit': 'Lợi nhuận',
  'kpi.roas': 'ROAS',
  // Generic table columns
  'tcol.code': 'Mã',
  'tcol.name': 'Tên',
  // HR config
  'hrcfg.workdays': 'Ngày làm việc',
  'hrcfg.morningHours': 'Giờ sáng',
  'hrcfg.afternoonHours': 'Giờ chiều',
  'hrcfg.annualBase': 'Phép năm cơ bản',
  // Login logs
  'logs.user': 'Người dùng',
  'logs.time': 'Thời gian',
};
